import { createAction, props } from '@ngrx/store';

import { Force, Platoon, PointsAdjustment, Unit } from '../models';

export const FORCE_ACTIONS = {
    LOAD_ALL_FORCES: createAction('[Force] loadAllForces', props<{ forces: Force[] }>()),
    ADD_FORCE: createAction('[Force] addForce', props<{ force: Force }>()),
    UPDATE_FORCE: createAction('[Force] updateForce', props<{ force: Partial<Force> & { id: string } }>()),
    UPDATE_FORCES_BATCH: createAction('[Force] updateForcesBatch', props<{ forces: Array<Partial<Force> & { id: string }> }>()),
    UPDATE_FORCES_BATCH_TIMESTAMPS: createAction(
        '[Force] updateForcesBatchTimestamps',
        props<{ forces: Array<{ id: string; updatedAt: number }> }>()
    ),
    UPDATE_FORCE_TIMESTAMP: createAction('[Force] updateForceTimestamp', props<{ id: string; updatedAt: number }>()),
    UPSERT_FORCE: createAction('[Force] upsertForce', props<{ force: Force }>()),
    UPSERT_FORCE_WITHOUT_UPLOAD: createAction('[Force] upsertForceWithoutUpload', props<{ force: Force }>()),
    DELETE_FORCE: createAction('[Force] deleteForce', props<{ id: string; updatedAt: number }>()),
    ADD_POINTS_ADJUSTMENT: createAction(
        '[Force] addPointsAdjustment',
        props<{ forceId: string; unitId?: string; pointsAdjustment: PointsAdjustment }>()
    ),
    REMOVE_POINTS_ADJUSTMENT: createAction('[Force] removePointsAdjustment', props<{ forceId: string; unitId?: string; index: number }>()),
    DELETE_PLATOON: createAction('[Force] deletePlatoon', props<{ forceId: string; platoonId: number }>()),
    DUPLICATE_PLATOON: createAction('[Force] duplicatePlatoon', props<{ forceId: string; platoonId: number }>()),
    ADD_PLATOON: createAction('[Force] addPlatoon', props<{ forceId: string; platoon: Platoon }>()),
    ADD_UNIT_OPTION: createAction('[Force] addUnitOption', props<{ forceId: string; unitId: string; optionId: number }>()),
    ADD_UNIT: createAction('[Force] addUnit', props<{ forceId: string; unit: Unit }>()),
    REMOVE_UNIT_OPTION: createAction('[Force] removeUnitOption', props<{ forceId: string; unitId: string; optionId: number }>())
};
